import { lazy } from 'react';

const MindMapView = lazy(() => import('./components/MindMapView'));
const DocumentInsightsView = lazy(() => import('./components/DocumentInsightsView'));

export const documentRoutes = [
  { path: '/documents/:documentId/mindmap', element: <MindMapView /> },
  { path: '/documents/:documentId/insights', element: <DocumentInsightsView /> },
];
